import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Links a user (Seeker or Company) to a franchise based on their location (District).
 * @param {string} userId - The ID of the user/entity.
 * @param {Object} locationData - Object containing { state, district }.
 */
export const linkUserToFranchise = async (userId, locationData) => {
    try {
        const { state, district } = locationData;

        if (!state || !district) {
            console.log('Skipping franchise link: Missing state or district');
            return { success: false, message: 'Missing location data' };
        }

        console.log(`Checking for franchise covering: ${state}, ${district}`);

        const franchisesRef = collection(db, 'franchises');

        // Create the target area object to match the structure in assignedAreas
        // Note: This must match the structure saved in SuperAdminFranchiseManagement.jsx
        const targetArea = {
            state: state,
            district: district,
            taluka: 'All'
        };

        // Query for a franchise that has this specific area in its assignedAreas array
        const q = query(franchisesRef, where('assignedAreas', 'array-contains', targetArea));

        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const franchiseDoc = querySnapshot.docs[0];
            const franchiseId = franchiseDoc.id;
            const franchiseName = franchiseDoc.data().name;

            console.log(`Found matching franchise: ${franchiseName} (${franchiseId})`);

            // Update the user's profile with the franchise ID and referral info
            const userRef = doc(db, 'users', userId);

            await updateDoc(userRef, {
                referredBy: franchiseId,
                franchiseId: franchiseId,
                franchiseLinkedAt: new Date()
            });

            console.log(`Successfully linked user ${userId} to franchise ${franchiseId}`);
            return { success: true, franchiseId };
        } else {
            console.log(`No matching franchise found for ${state}, ${district}`);
            return { success: false, message: 'No matching franchise found' };
        }
    } catch (error) {
        console.error('Error linking user to franchise:', error);
        return { success: false, error: error.message };
    }
};
